import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { sportsApi } from '../SportsAuthContext';
import { AuthShell, SportsInput, SportsButton } from '../components/AuthShell';

export default function SportsResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mismatch, setMismatch] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error('Password must be at least 8 characters'); return; }
    if (password !== confirmPassword) { setMismatch(true); return; }
    setMismatch(false);
    setBusy(true);
    try {
      await sportsApi.post('/sports/auth/reset-password', { token, new_password: password });
      toast.success('Password reset. Please sign in.');
      navigate('/sports/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed. Request a new link.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Set New Password"
      subtitle="Choose a strong password for your account."
      footer={<Link to="/sports/login" className="text-[#E63946] font-semibold" data-testid="sports-reset-back-link">Back to sign in</Link>}
    >
      {!token ? (
        <div className="rounded-md border border-[#E63946]/40 bg-[#E63946]/10 px-4 py-3 text-sm text-[#E63946]" data-testid="sports-reset-no-token">
          Missing or invalid reset link. Please request a new one.
        </div>
      ) : (
        <form onSubmit={submit}>
          <SportsInput label="New Password" type="password" testid="sports-reset-password" value={password}
            onChange={(e) => { setPassword(e.target.value); setMismatch(false); }} required placeholder="At least 8 characters" />
          <SportsInput label="Confirm New Password" type="password" testid="sports-reset-confirm-password" value={confirmPassword}
            onChange={(e) => { setConfirmPassword(e.target.value); setMismatch(false); }} required placeholder="Repeat your new password" />
          {mismatch && (
            <p className="text-xs mb-3 -mt-2" style={{ color: '#E63946' }} data-testid="reset-password-mismatch-error">
              Passwords do not match. Please try again.
            </p>
          )}
          <SportsButton type="submit" testid="sports-reset-submit" disabled={busy}>
            {busy ? 'Saving…' : 'Reset Password'}
          </SportsButton>
        </form>
      )}
    </AuthShell>
  );
}
